import { cn } from "@shared/lib/utils";

type StatusType =
  | "pending"
  | "Started"
  | "completed"
  | "failed"
  | "warning"
  | "success"
  | "info"; // Added "info" status type

interface StatusBadgeProps {
  status: StatusType;
  label?: string;
  className?: string;
}

const statusConfig = {
  pending: {
    class: "bg-gray-100 text-gray-800 border border-gray-200",
    defaultLabel: "Pending",
  },
  Started: {
    class: "bg-blue-100 text-blue-800 border border-blue-200",
    defaultLabel: "In Progress",
  },
  completed: {
    class: "bg-green-100 text-green-800 border border-green-200",
    defaultLabel: "Completed",
  },
  failed: {
    class: "bg-red-100 text-red-800 border border-red-200",
    defaultLabel: "Failed",
  },
  warning: {
    class: "bg-yellow-100 text-yellow-800 border border-yellow-200",
    defaultLabel: "Warning",
  },
  success: {
    class: "bg-green-100 text-green-800 border border-green-200",
    defaultLabel: "Success",
  },
  info: {
    class: "bg-blue-100 text-blue-800 border border-blue-200",
    defaultLabel: "Info",
  },
};

export function StatusBadge({ status, label, className }: StatusBadgeProps) {
  const config = statusConfig[status];

  return (
    <span
      className={cn(
        "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium",
        config.class,
        className
      )}
    >
      {label || config.defaultLabel}
    </span>
  );
}
